export function setAggregatedData(state, data) {
  return {
    ...state,
    ...data,
  };
}
